<!--<icn-number-input
                  [min]="0"
                  [max]="1000"
                  [maxLength]="5"
                  [sign]="'%'"
                  [step]="0.5"
                  [useDefaultHtmlInput]="true"
                  [value]="getPercent()"
                  (valueChange)="onValueChange($event)"
></icn-number-input>
-->
<icn-number-input
  [theme]="'white'"
  [min]="0"
  [max]="1000"
  [step]="0.5"
  [value]="selectedValue"
  (valueChange)="onValueChange($event)"
></icn-number-input>
